<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="snackbars.errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericInfoSnackbar" color="primary">

      {{ snackbars.genericInfoText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericInfoSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericErrorSnackbar" color="error">

      {{ snackbars.genericErrorText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericErrorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-dialog v-model="dialogs.updatePaymentStatusToRefundedDialog" persistent max-width="800" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Update Payment Status to Refunded</strong></v-card-title>

        <v-card-text class="mt-2">

          <p class="caption">(*) indicates a required field</p>

          <v-row>

            <v-col cols="3">

              <v-menu v-model="refundPaymentDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                <template v-slot:activator="{ on, attrs }">

                  <v-text-field v-model="refundPayment.transactionDate" label="Date*" hint="MM/DD/YYYY" maxlength="10" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="refundPaymentDatePicker = parseDate(refundPaymentDate)" v-on="on" outlined style="max-width: 175px" :error-messages="transactionDateOfRefundPaymentErrors"></v-text-field>

                </template>

                <v-date-picker v-model="refundPaymentDatePicker" no-title @input="refundPaymentDateMenu = false"></v-date-picker>

              </v-menu>

            </v-col>

            <v-col cols="5">

              <v-autocomplete label="Payment Method*" v-model="refundPayment.paymentMethod" :items="['Credit Card', 'Cheque']" style="max-width: 400px" outlined :error-messages="paymentMethodOfRefundPaymentErrors"></v-autocomplete>

            </v-col>

            <v-col cols="4">

              <v-text-field id="refundPaymentAmount" label="Amount" v-model="refundPayment.amount" style="max-width: 200px" outlined readonly prefix="$"></v-text-field>

            </v-col>

          </v-row>

          <v-textarea label="Description*" v-model="refundPayment.description" maxlength="250" style="max-width: 1000px" rows="4" class="mt-1" outlined :error-messages="descriptionOfRefundPaymentErrors"></v-textarea>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="dialogs.updatePaymentStatusToRefundedDialog = false">cancel</v-btn>

          <v-btn color="primary" @click="updatePaymentStatusToRefunded">save</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="searchDialog" persistent max-width="1000">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Search</strong></v-card-title>

        <v-card-text class="text-body-1">

          <v-layout class="mt-4" wrap>

            <v-row>

              <v-col>

                <v-text-field label="MV Number" v-model="searchFilter.parcelReferenceNumber" maxlength="9" outlined placeholder="eg. P-0001000"></v-text-field>

              </v-col>

              <v-col>

                <v-text-field label="Registration Number" v-model="searchFilter.registrationReferenceNumber" maxlength="9" outlined placeholder="eg. R-0001500"></v-text-field>

              </v-col>

              <v-col>

                <v-text-field label="Order Number" v-model="searchFilter.orderNumber" maxlength="26" outlined placeholder="eg. OB-00000001-20230629144842"></v-text-field>

              </v-col>

            </v-row>

            <v-row>

              <v-col>

                <v-text-field label="Account (Email)" v-model="searchFilter.email" maxlength="100" outlined></v-text-field>

              </v-col>

              <v-col>

                <v-autocomplete label="Payment Method" v-model="searchFilter.paymentMethod" hide-no-data :items="['Credit Card', 'Cheque', 'Cash']" outlined></v-autocomplete>

              </v-col>

              <v-col>

                <v-autocomplete label="Payment Status" v-model="searchFilter.paymentStatus" hide-no-data :items="['Payment in Progress', 'Void', 'Declined', 'Paid', 'Pending Refund', 'Refund In Progress', 'Refunded']" outlined></v-autocomplete>

              </v-col>

            </v-row>

            <v-row>

              <v-col>

                <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                  <template v-slot:activator="{ on, attrs }">

                    <v-text-field v-model="searchFilter.transactionStartDate" label="Start Date" hint="MM/DD/YYYY" maxlength="10" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="startDatePicker = parseDate(searchFilter.transactionStartDate)" v-on="on" outlined style="max-width: 175px"></v-text-field>

                  </template>

                  <v-date-picker v-model="startDatePicker" no-title @input="startDateMenu = false"></v-date-picker>

                </v-menu>

              </v-col>

              <v-col>

                <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                  <template v-slot:activator="{ on, attrs }">

                    <v-text-field v-model="searchFilter.transactionEndDate" label="End Date" hint="MM/DD/YYYY" maxlength="10" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="endDatePicker = parseDate(searchFilter.transactionEndDate)" v-on="on" outlined style="max-width: 175px"></v-text-field>

                  </template>

                  <v-date-picker v-model="endDatePicker" no-title @input="endDateMenu = false"></v-date-picker>

                </v-menu>

              </v-col>

              <v-col>

                <v-text-field label="Transaction Number" v-model="searchFilter.transactionNumber" hide-no-data outlined></v-text-field>

              </v-col>

            </v-row>

          </v-layout>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="searchDialog = false" color="primary">cancel</v-btn> <v-btn @click="search" color="primary">search</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.orderDetailsDialog" persistent max-width="800" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break">Order Details</v-card-title>

        <v-card-text class="mt-2">

          <div><strong>Order Number:</strong> {{ order.orderNumber }}</div>

          <div v-if="order.cardHolder"><strong>Card Holder:</strong> {{ order.cardHolder }}</div>

          <div v-if="order.expiry"><strong>Expiry:</strong> {{ order.expiry }}</div>

          <div v-if="order.cardType"><strong>Card Type:</strong> {{ order.cardType }}</div>

          <div><strong>Transaction Date:</strong> {{ order.transactionDate }}</div>

          <div><strong>Transaction Total:</strong> {{ order.transactionTotal }}</div>

          <div><strong>Payment Status:</strong> {{ order.paymentStatus }}</div>

          <div v-if="order.paymentMethod"><strong>Payment Method:</strong> {{ order.paymentMethod }}</div>

          <div v-if="order.transactionNumber"><strong>Transaction Number:</strong> {{ order.transactionNumber }}</div>

          <div><strong>Description:</strong> {{ order.description }}</div>

          <div><strong>Manual:</strong> {{ order.isManual }}</div>

          <div class="mt-4" v-if="$store.state.user.role == 'Admin' && order.paymentStatus == 'Pending Refund'"><a href="#" @click="openUpdatePaymentToRefundedDialog">Update Payment Status to Refunded</a></div>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="dialogs.orderDetailsDialog = false">close</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-card elevation="0" class="pa-2">

      <v-card-title class="text-h5 word-break"><strong>Orders</strong></v-card-title>

      <v-card-text class="text-body-1">

        <div class="text-right">

          <v-btn color="primary" class="mb-4" @click="openSearchDialog"><v-icon left>mdi-magnify</v-icon>search</v-btn> <v-btn color="primary" class="mb-4" @click="reset">reset</v-btn>

        </div>

        <v-data-table :headers="headers" :items="orders" class="elevation-1" @click:row="rowClick" :sort-desc="true" :loading="loadingTable">

        </v-data-table>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";
import {required} from "vuelidate/lib/validators";

export default Vue.extend({

  name: 'DateTime',

  validations: {

    refundPayment: {

      transactionDate: {

        required

      },

      paymentMethod: {

        required

      },

      description: {

        required

      }

    }

  },

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

        let query = { data: null as any };

        this.loading = false;

        this.orders = query.data;

      }
      catch (error:any)
      {
        // there was an exception

        if (error.response && error.response.status == 401) {

          // the exception is "Unauthorized", redirect to login screen

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }
        else if (error.response && error.response.status == 404) {

          // the exception is "404 Not Found", redirect to 404 screen

          if (this.$route.path != '/NotFound') this.$router.push('/NotFound');

        }
        else {

          // all other exceptions

          this.clearSnackbars();

          this.snackbars.genericErrorText = 'There was an issue contacting the server.';

          this.snackbars.genericErrorSnackbar = true;

        }
      }

    }, 200)

  },

  watch: {

    refundPaymentDatePicker (val) {

      this.refundPayment.transactionDate = this.formatDate(this.refundPaymentDatePicker)

    },

    startDatePicker (val) {

      this.searchFilter.transactionStartDate = this.formatDate(this.startDatePicker)

    },

    endDatePicker (val) {

      this.searchFilter.transactionEndDate = this.formatDate(this.endDatePicker)

    }

  },

  computed: {

    transactionDateOfRefundPaymentErrors()
    {
      if (!this.$v.refundPayment.$dirty) return [];

      if (this.$v.refundPayment.transactionDate && !this.$v.refundPayment.transactionDate.required)
      {
        return ['Date is required.'];
      }

      return [];

    },

    paymentMethodOfRefundPaymentErrors()
    {
      if (!this.$v.refundPayment.$dirty) return [];

      if (this.$v.refundPayment.paymentMethod && !this.$v.refundPayment.paymentMethod.required)
      {
        return ['Payment Method is required.'];
      }

      return [];

    },

    descriptionOfRefundPaymentErrors()
    {
      if (!this.$v.refundPayment.$dirty) return [];

      if (this.$v.refundPayment.description && !this.$v.refundPayment.description.required)
      {
        return ['Description is required.'];
      }

      return [];

    }

  },

  methods: {

    clearSnackbars() {

      this.snackbars.errorSnackbar = false;

      this.snackbars.genericInfoSnackbar = false;

      this.snackbars.genericErrorSnackbar = false;

    },

    openUpdatePaymentToRefundedDialog() {

      this.clearSnackbars();

      this.dialogs.orderDetailsDialog = false;

      this.loading = true;

      setTimeout(async () => {

        try {

          let obj = await axios.get('api/Order/GetOrderDetails?id=' + this.id);

          this.loading = false;

          this.refundPayment.amount = obj.data.transactionTotal.replace('$', '');

        } catch (error) {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 200)

      this.refundPayment.transactionDate = '';

      this.refundPayment.paymentMethod = '';

      this.refundPayment.amount = '';

      this.refundPayment.description = '';

      this.$v.refundPayment.$reset();

      this.dialogs.updatePaymentStatusToRefundedDialog = true;

    },

    updatePaymentStatusToRefunded() {

      this.$v.$touch();

      if (!this.$v.$error) {

        this.dialogs.updatePaymentStatusToRefundedDialog = false;

        this.loading = true;

        setTimeout(async () => {

          this.refundPayment.id = this.id;

          let obj = await axios.post('api/Checkout/UpdatePaymentStatusToRefunded', this.refundPayment);

          this.loading = false;

          this.refreshOrders();

          this.snackbars.genericInfoText = 'The payment status has been updated to Refunded.';

          this.snackbars.genericInfoSnackbar = true;

        }, 200);

      }
      else
      {
        this.snackbars.errorSnackbar = true;
      }

    },

    rowClick(obj: any)
    {
      this.clearSnackbars();

      this.id = obj.id;

      this.loading = true;

      setTimeout(async () => {

        try {

          let query = await axios.get('api/Order/GetOrderDetails?id=' + obj.id);

          this.loading = false;

          this.order = query.data;

          this.dialogs.orderDetailsDialog = true;

        } catch (error) {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 200)
    },

    async refreshOrders() {

      this.loadingTable = true;

      let obj = { data: null as any };

      this.loadingTable = false;

      this.orders = obj.data;

    },

    search() {

      this.searchDialog = false;

      this.refreshOrders();

    },

    async reset() {

      this.clearSnackbars();

      this.searchFilter.parcelReferenceNumber = '';

      this.searchFilter.registrationReferenceNumber = '';

      this.searchFilter.orderNumber = '';

      this.searchFilter.email = '';

      this.searchFilter.paymentMethod = '';

      this.searchFilter.paymentStatus = '';

      this.searchFilter.transactionNumber = '';

      this.searchFilter.transactionStartDate = '';

      this.searchFilter.transactionEndDate = '';

      this.refreshOrders();

    },

    formatDate (date:any):any {

      if (!date) return null

      const [year, month, day] = date.split('-')

      return `${month}/${day}/${year}`

    },

    parseDate (date:any):any {

      if (!date) return null

      const [month, day, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

    },

    openSearchDialog()
    {
      this.clearSnackbars();

      this.searchFilter.parcelReferenceNumber = '';

      this.searchFilter.registrationReferenceNumber = '';

      this.searchFilter.orderNumber = '';

      this.searchFilter.email = '';

      this.searchFilter.paymentMethod = '';

      this.searchFilter.paymentStatus = '';

      this.searchFilter.transactionNumber = '';

      this.searchFilter.transactionStartDate = '';

      this.searchFilter.transactionEndDate = '';

      this.searchDialog = true;
    }

  },

  data () {

    return {

      refundPayment: {

        id: null as number | null,

        transactionDate: '',

        paymentMethod: '',

        amount: '',

        description: ''

      },

      refundPaymentDateMenu: false,

      refundPaymentDatePicker: '',

      refundPaymentDate: '',

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

      },

      id: null,

      description: '',

      order: {

        orderNumber: '',

        cardHolder: '',

        expiry: '',

        cardType: '',

        transactionDate: '',

        transactionTotal: '',

        paymentStatus: '',

        paymentMethod: '',

        transactionNumber: '',

        description: '',

        isManual: ''

      },

      dialogs: {

        updatePaymentStatusToRefundedDialog: false,

        orderDetailsDialog: false

      },

      startDateMenu: false,

      startDatePicker: '',

      endDateMenu: false,

      endDatePicker: '',

      loading: false,

      loadingTable: false,

      orders: [],

      headers: [

        { text: 'Order Number', value: 'orderNumber', class: 'primary white--text'},

        { text: 'Payment Method', value: 'paymentMethod', class: 'primary white--text' },

        { text: 'Transaction Date', value: 'transactionDate', class: 'primary white--text' },

        { text: 'Transaction Total', value: 'transactionTotal', class: 'primary white--text' },

        { text: 'Transaction Number', value: 'transactionNumber', class: 'primary white--text' },

        { text: 'Payment Status', value: 'paymentStatus', class: 'primary white--text' },

        { text: 'Manual', value: 'isManual', class: 'primary white--text' }

      ],

      searchDialog: false,

      searchFilter: {

        parcelReferenceNumber: '',

        registrationReferenceNumber: '',

        orderNumber: '',

        email: '',

        paymentMethod: '',

        paymentStatus: '',

        transactionStartDate: '',

        transactionEndDate: '',

        transactionNumber: ''
      }

    }

  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

th > .v-icon {

  color: white !important;

}

th, td {

  font-size: 18px !important;

}

</style>
